import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import TopPhoneBar from "@/components/TopPhoneBar";
import CookieBanner from "@/components/CookieBanner";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#F6F0E7] text-[#203240]">
      <TopPhoneBar />
      <Navbar />
      <main className="pt-[148px]">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
